import { ReactComponent as FloatMenuLogoSVG } from "./float-menu-logo.svg";
import { SvgIcon } from '@mui/material';

export default function LogoFloatMenuL(props) {
  return <SvgIcon {...props} component={FloatMenuLogoSVG} viewBox="0 0 70.3 33.8" />;
}